/**
 * What Position in Stack starts as on a new deal.
 *
 * Mirrors `backend/app/core/position_default.py`, and must change with it, or
 * the form promises one position and the server records another. `whole_loan`
 * is Chris Young's ruling of 26 Oct 2026 ("I would assume 'Whole Loan' is the
 * default unless otherwise changed"), shipped since Louis Rosenberg's written
 * yes of 27 Oct 2026; `senior` was the default before. Never types the value
 * into the form: it shows as "(default)" on the empty option, and the server
 * records it as a Suggestion (`source = "default"`).
 */
export const POSITION_DEFAULT_SENIOR = 'senior'
export const POSITION_DEFAULT_WHOLE_LOAN = 'whole_loan'

export type PositionDefault = typeof POSITION_DEFAULT_SENIOR | typeof POSITION_DEFAULT_WHOLE_LOAN

export const POSITION_DEFAULT_MODES: readonly PositionDefault[] = [
  POSITION_DEFAULT_SENIOR,
  POSITION_DEFAULT_WHOLE_LOAN,
]

export const DEFAULT_POSITION_DEFAULT: PositionDefault = POSITION_DEFAULT_WHOLE_LOAN

/** The two values a stack position may start as, in the catalogue's spelling. */
export const POSITION_SENIOR = 'Senior'
export const POSITION_WHOLE_LOAN = 'Whole Loan'

let current: PositionDefault = DEFAULT_POSITION_DEFAULT

export function positionDefault(): PositionDefault {
  return current
}

export function setPositionDefault(mode: PositionDefault): void {
  switch (mode) {
    case POSITION_DEFAULT_SENIOR:
    case POSITION_DEFAULT_WHOLE_LOAN:
      current = mode
      return
    default: {
      const _never: never = mode
      throw new Error(`POSITION_DEFAULT must be senior or whole_loan, got ${_never}`)
    }
  }
}

export function resetPositionDefault(): void {
  current = DEFAULT_POSITION_DEFAULT
}

/** The stack position a deal starts at when nothing states one. */
export function defaultPosition(): string {
  return current === POSITION_DEFAULT_WHOLE_LOAN ? POSITION_WHOLE_LOAN : POSITION_SENIOR
}
